import React from 'react';

export const BrandLogo = () => {
  return (
    <a className="logo" href="https://usdnova.com" aria-label="Nova home">
      <img src="/nova-wordmark.svg" alt="" className="logo-wordmark" aria-hidden="true" />
      <img src="/nova-starburst.svg" alt="" className="logo-icon-img" aria-hidden="true" />
    </a>
  );
};
